<template>
  <sc-page-base title="Envio de CT-e" :loading="loadingUploadForm">
    <sc-cte-upload-form />
    <sc-cte-upload-list />
  </sc-page-base>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

import { ScPageBase } from '@intelipost-js/secure-components';

import ScCteUploadForm from './components/sc-cte-upload-form/ScCteUploadForm';
import ScCteUploadList from './components/sc-cte-upload-list/ScCteUploadList';

const { mapState } = createNamespacedHelpers('recon/cteUpload');

export default {
  name: 'cte-upload',
  computed: {
    ...mapState(['loadingUploadForm']),
  },
  components: {
    ScCteUploadForm,
    ScCteUploadList,
    ScPageBase,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/cte-upload/PageCTeUpload.vue?5ca64fe4